<template>
  <div id="main" style="overflow-y: scroll" class="height100">
    <div class="fixed">
      <ul>
        <li @click="kefu"><span>在线<br/>客服</span></li>
      </ul>
    </div>
    <el-backtop target="#main"></el-backtop>
    <el-popover ref="loginPopover" placement="bottom" width="250" trigger="click" popper-class="login-popper">
      <login top="0px"></login>
    </el-popover>
    <el-popover ref="appPopover" placement="bottom" width="250" trigger="hover">
      <!--el-image :src="require('../../assets/bestimade_ercode.jpg')" fit="contain"></el-image-->
      <img :src="require('../../assets/bestimade_ercode.jpg')" class="width100 height100" fit="contain"/>
    </el-popover>
    <el-popover ref="wechatPopover" placement="bottom" width="250" trigger="hover">
      <!--el-image :src="require('../../assets/bestimade_wechat.jpg')"></el-image-->
      <img :src="require('../../assets/bestimade_wechat.jpg')" class="width100 height100" fit="contain"/>
    </el-popover>
    <el-popover ref="miniWechatPopover" placement="bottom" width="250" trigger="hover">
      <!--el-image :src="require('../../assets/bestimade_mini.jpg')"></el-image-->
      <img :src="require('../../assets/bestimade_mini.jpg')" class="width100 height100" fit="contain"/>
    </el-popover>
    <div class="main-header">
      <div class="header-top">
        <div class="top">
          <div class="flex-1"></div>
          <div class="login-info">
            <el-link v-popover:appPopover class="link" type="info" :underline="false">手机版</el-link>
            <el-link v-popover:wechatPopover class="link" type="info" :underline="false">公众号</el-link>
            <el-link v-popover:miniWechatPopover class="link" type="info" :underline="false">小程序</el-link>
            <span style="margin: 0 10px;color: #ddd">|</span>
            <el-link v-popover:loginPopover :underline="false" v-if="!ifUserLogin" class="link">登录</el-link>
            <el-link v-if="!ifUserLogin" class="btn-register link" type="danger" @click="jump2Register">免费注册</el-link>
            <el-link v-if="ifUserLogin" class="link" icon="el-icon-message" @click="handleMessageClick">{{messageNumber === 0 ? '消息' : '消息(' + messageNumber + ')'}}</el-link>
            <el-link v-if="ifUserLogin" class="user link" type="warning" @click="handleUserClick">{{nickname}}</el-link>
            <span v-if="ifUserLogin" style="margin: 0 10px;color: #ddd">|</span>
            <el-link v-if="ifUserLogin" class="link" @click="handleUserLogout">退出</el-link>
          </div>
        </div>
      </div>
      <div class="header-logo">
        <div class="logo flex">
          <div class="bg-logo" @click="home"></div>
          <div class="slogan" @click="home">
            <div style="font-size: 25px">互联制造</div>
            <div>BESTIMADE<sup>®</sup></div>
          </div>
          <div class="search-box">
              <el-input @keyup.enter.native="onSearch" placeholder="请输入搜索内容" v-model="search.text" class="input-with-select">
                <el-select v-model="search.type" slot="prepend" placeholder="请选择">
                  <el-option label="采购需求" value="demand"></el-option>
                  <el-option label="供应资源" value="supply"></el-option>
                  <el-option label="企业产品" value="company"></el-option>
                </el-select>
                <el-button @click="onSearch" slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div>
          <div class="search-button flex-1">
            <el-row>
              <el-col :span="24">
                <el-button type="primary" round @click="handleNewDemand">发布新需求</el-button>
                <el-button type="primary" round @click="handleNewSupply">发布新资源</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="header-nav">
        <el-menu
            :default-active="activeMenuIndex"
            class="el-menu-nav"
            mode="horizontal"
            @select="handleSelect"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
            style="border-bottom: 0">
          <el-menu-item index="home">首页</el-menu-item>
          <el-menu-item index="company">企业资源</el-menu-item>
          <el-menu-item index="demand">采购需求</el-menu-item>
          <el-menu-item index="supply">供应资源</el-menu-item>
          <el-menu-item index="case">成功案例</el-menu-item>
          <el-menu-item index="about">关于我们</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="main-body">
      <!--transition name="fade" mode="out-in">
        <keep-alive>
          <router-view class="main-content"></router-view>
        </keep-alive>
      </transition-->
      <transition name="fade" mode="out-in">
          <router-view class="main-content"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
  import Login from '@/view/login/login'
  import { mapGetters, mapMutations } from 'vuex'
  import router from '../../router'
  import { Menu, Duty } from '../../util/constants'
  import { getLoginUser, clearLoginUser } from '../../util/common'
  import { apiLogout, apiUnreadNoticeCount } from '../../api/user'

  export default {
    name: 'main-index',
    components: {
      Login
    },
    data() {
      return {
        loginUser: null,
        search: {
          text: '',
          type: 'demand'
        },
        ifUserLogin: false
      }
    },
    created() {
      this.loginUser = getLoginUser()
      this.refreshMessageNumber()
      let _this = this
      this.$gon('refreshLoginUser', () => {
        _this.loginUser = getLoginUser()
        if (_this.loginUser != null) {
          _this.ifUserLogin = true
        } else {
          _this.ifUserLogin = false
        }
      })
    },
    computed: {
      ...mapGetters([
        'activeMenuIndex',
        'messageNumber'
      ]),
      nickname() {
        return this.loginUser == null ? 'null' : this.loginUser.nickName
      },
      ifShowDemand() {
        // let loginUser = getLoginUser()
        if (this.loginUser == null) {
          return true
        } else {
          if (this.loginUser.userType === Duty.Buyer) {
            return true
          } else if (this.loginUser.userType === Duty.Seller) {
            return false
          } else {
            return true
          }
        }
      },
      ifShowSupply() {
        // let loginUser = getLoginUser()
        if (this.loginUser == null) {
          return true
        } else {
          if (this.loginUser.userType === Duty.Buyer) {
            return false
          } else if (this.loginUser.userType === Duty.Seller) {
            return true
          } else {
            return true
          }
        }
      }
    },
    methods: {
      getLoginUser,
      kefu() {
        window.open('tencent://message/?uin=3258006098&Site=qq&Menu=yes', '_blank')
      },
      refreshMessageNumber() {
        let loginUser = getLoginUser()
        if (loginUser != null) {
          this.ifUserLogin = true
          apiUnreadNoticeCount().then(({module}) => { this.setMessageNumber(module) })
        }
      },
      handleSelect(index, indexPath) {
        /* if (index === Menu.About) {
          window.open('http://www.bestimade.com', '_blank')
        } else {
          router.push({ name: index })
        } */
        router.push({ name: index })
      },
      handleUserClick() {
        this.$router.push({
          path: `/user`
        })
        this.$gemit('selectUserActiveMenuIndex', Menu.User.MyProfile)
      },
      handleUserLogout() {
        apiLogout().then(() => {
          clearLoginUser()
          window.location.href = window.location.pathname
        }).catch(() => {
          clearLoginUser()
          window.location.href = window.location.pathname
        })
      },
      handleMessageClick() {
        this.$router.push({
          name: 'user',
          params: {
            tab: Menu.User.MyMessage
          }
        })
        this.$gemit('selectUserActiveMenuIndex', Menu.User.MyMessage)
      },
      onSearch() {
        if (this.search.type === 'demand') {
          this.$router.push({
            name: 'demand',
            params: {
              search: this.search.text
            }
          })
          this.$gemit('demandSearch', this.search.text)
        }
        if (this.search.type === 'supply') {
          this.$router.push({
            name: 'supply',
            params: {
              search: this.search.text
            }
          })
          this.$gemit('supplySearch', this.search.text)
        }
        if (this.search.type === 'company') {
          this.$router.push({
            name: 'company',
            params: {
              search: this.search.text
            }
          })
          this.$gemit('companySearch', this.search.text)
        }
      },
      handleNewDemand() {
        if (this.ifUserLogin === false) {
          this.$alert('您尚未登录,请先登录', '错误', { confirmButtonText: '好的' })
          return
        }
        if (getLoginUser().hasCompany === undefined || getLoginUser().hasCompany === 0 || getLoginUser().hasCompany == null) {
          this.$alert('请先完善企业信息', '提示', {
            confirmButtonText: '去完善',
            callback: action => {
              this.$router.push({
                path: `/user`
              })
              this.$gemit('selectUserActiveMenuIndex', Menu.User.MyProfile)
            }
          })
          return
        }
        this.$router.push({
          name: 'user',
          params: {
            tab: Menu.User.PublishDemand
          }
        })
        this.$gemit('selectUserActiveMenuIndex', Menu.User.PublishDemand)
      },
      handleNewSupply() {
        if (this.ifUserLogin === false) {
          this.$alert('您尚未登录,请先登录', '错误', { confirmButtonText: '好的' })
          return
        }
        if (getLoginUser().hasCompany === undefined || getLoginUser().hasCompany === 0 || getLoginUser().hasCompany == null) {
          this.$alert('请先完善企业信息', '提示', {
            confirmButtonText: '去完善',
            callback: action => {
              this.$router.push({
                path: `/user`
              })
              this.$gemit('selectUserActiveMenuIndex', Menu.User.MyProfile)
            }
          })
          return
        }
        this.$router.push({
          name: 'user',
          params: {
            tab: Menu.User.PublishSupply
          }
        })
        this.$gemit('selectUserActiveMenuIndex', Menu.User.PublishSupply)
      },
      jump2Register() {
        this.$router.push({
          name: 'register'
        })
      },
      home() {
        this.$router.push({
          name: 'home'
        })
      },
      ...mapMutations({
        setActiveMenuIndex: 'SET_ACTIVE_MENU_INDEX',
        setMessageNumber: 'SET_MESSAGE_NUMBER'
      })
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import '../../style/variables.scss';
  .main-header {

  }

  .fixed {
    position: fixed;
    background: #FFFFFF;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.2);
    left:0px;
    top: 50%;
    z-index: 3;
    ul {
      list-style: none;
    }
    li {
      padding: 5px;
      color: white;
      background-color: $theme-yellow;
      border: 0;
      cursor: pointer;

    }
  }

  .login-popper >>> .login-form {
    width: 100% !important;
    margin: 0 !important;
  }
  /*.main-header >>> .el-input-group__append {
    color: $theme-green;
    background-color: white;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    border: 1px solid $theme-green;
  }
  .main-header >>> .el-input-group__prepend {
    font-family: "微软雅黑";
    color: $theme-green;
    background-color: white;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    border: 1px solid $theme-green;
  }
  .main-header >>> input {
    font-family: "微软雅黑";
    border: {
      left: 0;
      bottom: 1px solid $theme-green;
      top: 1px solid $theme-green;
      right: 0;
    }
  }*/
  .main-header >>> .el-input-group__append {
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
  }
  .main-header >>> .el-input-group__prepend {
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
  }

  .input-with-select >>> input {
    font-size: 16px;
    font-family: '微软雅黑';
  }

  .header-top {
    font-size: 12px;
    background-color: #f7f7f7;
    .top {
      width: $container-width;
      display: flex;
      margin: 0 auto;
      height: 37px;
      line-height: 37px;
      .login-info {
        .btn-login {
          display: inline-block;
          padding: 0 10px;
          color: white;
          background-color: #00b7ff;
          &:hover {
            cursor: pointer;
          }
        }
        .btn-register {
          color: red;
          margin-left: 10px;
        }
      }
    }
  }

  .header-logo {
    width: $container-width;
    margin: 20px auto 0 auto;
    .logo {
      align-items: center;
      .bg-logo {
        width: 80px;
        height: 80px;
        background-image: url("../../assets/bestimade_logo.jpg");
        background-repeat:no-repeat;
        background-size: contain;
        cursor: pointer;
      }
      .slogan {
        font-weight: bold;
        font-size: 20px;
        margin-left: 20px;
        align-items: center;
        text-align: center;
        cursor: pointer;
      }
      .search-box {
        margin-left: 40px;
        .el-select {
          width: 110px;
        }
        .el-input {
          width: 500px;
        }
      }
      .search-button {
        text-align: center;
        & >>> button {
          font-size: 16px;
          font-family: '微软雅黑';
        }
      }
    }
  }

  .header-nav {
    margin-top: 20px;
    background-color: rgb(84, 92, 100);
    .el-menu-nav {
      display: table;
      text-align: center;
      margin: 0 auto;
      & >>> .el-menu-item {
        height: 40px;
        line-height: 40px;
        width: 200px;
        font-weight: bold;
        font-size: 18px;
        /*border: {
          left: 1px solid $theme-green;
          right: 1px solid $theme-green;
        };*/
      }
    }
  }

  .main-body {
    width: $container-width;
    margin: 0 auto;
  }

  .link {
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    padding: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/view/main/index.vue